import React, { useEffect, useState } from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../common/Header'
import { Outlet } from 'react-router-dom';

export default function DashboardLayout() {

    const [isSidebarToggled, setIsSidebarToggled] = useState(false);
    const [isSidebarHovered, setIsSidebarHovered] = useState(false);
    // const isSidebarVisuallyExpanded = isSidebarToggled || isSidebarHovered;

    // -----------------------------------------------------

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize(); // run once on mount
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isSidebarVisible = isMobile ? isSidebarToggled : true;


    return (
        <>
            <div className="app-container">
                {isSidebarVisible && (
                    <Sidebar
                        isToggled={isSidebarToggled}
                        isHovered={isSidebarHovered}
                        onToggle={() => setIsSidebarToggled(prev => !prev)}
                        onHoverChange={setIsSidebarHovered}
                        onCloseSidebar={() => isMobile && setIsSidebarToggled(false)} // for sidebar close in mobile when click
                    />
                )}
                <div className={`main-content ${isSidebarToggled ? 'content-expanded' : 'content-collapsed'}`} style={{ flex: 1 }}>
                    <Header
                        isMobile={isMobile}
                        onMenuClick={() => setIsSidebarToggled(prev => !prev)}
                    />
                    <Outlet />
                </div>

            </div>
        </>
    )
}


